import calls from './call'
import turn from './turn'

/**
 * Combine subreducers into a single call reducer.
 */
export default function (state = {}, action) {
  return {
    calls: calls(state.calls, action),
    turn: turn(state.turn, action)
  }
}
